import React from "react";
import discoverGroupImg from "../../Assets/About/discoverGroupImg.svg";

const DiscoverTheUtlitmate = () => {
  const handleBookNow = () => {
    const phoneNumber = '917327986868'; // Replace with your phone number including country code
    const message = `Hello, I would like to book an appointment with you.`;

    // URL encode the message to make sure it's formatted correctly
    const encodedMessage = encodeURIComponent(message);

    // Open WhatsApp with pre-filled message
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // Open the WhatsApp chat
    window.open(whatsappUrl, '_blank');
  };
  return (
    <div className="grid grid-cols-1 w-full h-fit  lg:grid-cols-2 p-8 md:p-16  gap-8 md:gap-16 ">
      <div className="w-full h-[100%] " data-aos="fade-right">
        <img
          className="w-full h-full md:object-cover "
          src={discoverGroupImg}
          alt="discoverGroupImg"
        />
      </div>
      <div className="flex flex-col gap-4 md:gap-8 my-auto " data-aos="fade-down">
        <div className="flex flex-col gap-2 justify-center">
          <h5 className="lato-thin-italic text-[#FF8F61] text-base">About Us</h5>
          <h2 className="text-3xl md:text-5xl  font-serif  font-semibold text-[#202020] md:leading-tight lg:leading-snug">
            Discover The Ultimate Spa Massage Experience
          </h2>
        </div>
        <div className="flex flex-col">
          <p className="text-black font-[500] poppins-thin leading-6  tracking-wide md:text-lg  text-base capitalize ">
            Discover A World Of Tranquility, Luxury, and personalized care as
            you embark on a journey of self-care and renewal. Visit us today and
            let us transport you to a realm of beauty and serenity.
          </p>
          <p className="text-black font-[500] poppins-thin leading-6  tracking-wide md:text-lg  text-base capitalize mt-4">
            We also offer private rooms for more intimate treatments and
            couples' packages for a romantic escape.
          </p>
        </div>
        <div className="">
          <button
          onClick={handleBookNow}
          className="py-3 px-12 text-white font-semibold bg-[#ff6a00] rounded">
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscoverTheUtlitmate;
